<template>
  <div class="commodity-rank">
    <div
      v-if="tableList.length"
      class="self-table"
    >
      <table
        border="0"
        style="border-collapse: collapse;"
      >
        <thead>
          <tr>
            <th
              scope="col"
              v-for="(item, index) in tableTitle"
              :key="index"
            >
              {{item}}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item,index) in tableList"
            :key="index"
            scope="row"
          >
            <th>{{ index+1 }}</th>
            <th
              style="color: #409EFF"
              @click="toCityRank(item)"
            >{{ item.commodityName }}</th>
            <td>{{ item.totalAmount }}</td>
            <td>{{ item.grossAmount }}</td>
            <td>{{ item.orderQuantity }}</td>
            <td>{{ item.bulkGoodsOrderQuantity }}</td>
            <td>{{ item.cutOrderQuantity }}</td>
            <td
              :class="item.operator== 1 ? 'colorRed' : 'colorGreen'"
            >
              <img
                v-if="item.operator== 0"
                src="@/assets/supplier-data/green.png"
              />
              <img
                v-else-if="item.operator== 1"
                src="@/assets/supplier-data/red.png"
              />
              {{ item.ratio }}%
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <DataEmpty
      v-else
      style="height: 200px;"
    />
  </div>
</template>

<script>
import { commoditySellingRank } from '@/api/crm';
import setHeaderMixins from '@/mixins/set-header';
import DataEmpty from '@/components/data-empty';

export default {
  name: 'CommodityRank',
  mixins: [setHeaderMixins],
  components: { DataEmpty },
  data() {
    return {
      tableTitle: ['排名', '名称', 'GMV', '毛利', '订单数', '大货数', '剪版数', '环比'],
      tableList: [
      //   {
      //   commodityName: '无敌是最寂寞最是痛苦', // 商品名称
      //   totalAmount: 1, // GMV
      //   grossAmount: 1, // 毛利
      //   orderQuantity: 1, // 订单数
      //   bulkGoodsOrderQuantity: 1, // 大货数
      //   cutOrderQuantity: 1, // 剪版数
      //   ratio: '100%', // 环比
      //   operator: '', // 下降: 0 / 上升: 1
      // }
      ],
      // query: {
      //   timeType: '',
      //   startDate: '',
      //   endDate: '',
      //   searchUserId: '',
      //   searchDepartmentId: '',
      //   purchaserCode: '',
      //   searchType: '',
      //   supplierCode: '', // 供应商编码
      // },
    };
  },
  watch: {
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      const { query } = this.$route;
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: '加载中...',
      });
      try {
        query.searchInfo = query.searchInfo ? JSON.parse(query.searchInfo) : '';
        const { data } = await commoditySellingRank(query);
        this.tableList = data?.rankInfos;
      } catch (e) {
        console.log(e);
      } finally {
        this.$toast.clear();
      }
    },
    toCityRank(item) {
      const { commodityNo } = item;
      window.JSBridge.invoke({
        bridgeName: 'toCityRank',
        data: {
          commodityNo,
        },
        callback: () => {},
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .self-table {
    tbody .colorRed {
      color: red;
    }
    tbody .colorGreen{
      color: #3fbf22;
    }
    th, td {
      min-width: 80px;
      max-width: 130px;
      text-align: center;
      height: 44px;
      empty-cells: show;
      overflow: hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      /*padding:0 6px;*/
      background: white;
      color: #999999;
      font-weight: 500;
      font-size: 14px;
      text-align:center;
      vertical-align:middle;
    }
    thead {
      th, td {
        background:rgba(245,245,249,1);
      }
      th {
        top:0;
        index: 2;
      }
      tr th:first-of-type {
        min-width: 35px;
        left:0; z-index:1;
      }
      tr th:nth-of-type(2){
        left:35px; z-index:1;
      }
    }
    table {
      table-layout:fixed;
    }
    th {
      position:-webkit-sticky;
      position:sticky;
    }

    tbody {
      th:first-of-type {
        min-width: 35px;
        left:0;
      }
      tr th:nth-of-type(2){
        left:35px;
      }
      td {
        padding: 0 5px;
      }
    }
    img {
      max-width: inherit;
    }
  }

</style>
